import * as Actions from '../constants/InventoryConstants';
import { deepCopy } from '../utils/objects';

const InitialState = {
    availableItems: {},
    initialInventory: {}
};

const Inventory = ( state = InitialState, action:any ) => {
    switch(action.type) {

        case Actions.SET_INITIAL_INVENTORY: 

            const { availableItems, initialOnly } = action.data

            if(initialOnly) {
                return { ...state, initialInventory: deepCopy(availableItems) }
            }

            return {
                ...state,
                initialInventory: deepCopy(availableItems),
                availableItems
            }

        case Actions.UPDATE_INGREDIENTS_IN_INVENTORY : 
            let newAvailableItems = deepCopy(state.availableItems);
            const { mode, inventoryPayload } = action.data;

            //This is based on if an item was added or removed from the cart
            switch (mode) {
                case Actions.INVENTORY_UPDATE_ACTION.REMOVE : 
                    for(const ingredientId in inventoryPayload) {
                        newAvailableItems[ingredientId].totalAvailableAmount -= inventoryPayload[ingredientId];
                    }
                    break;

                case Actions.INVENTORY_UPDATE_ACTION.ADD : 
                    for(const ingredientId in inventoryPayload) {
                        newAvailableItems[ingredientId].totalAvailableAmount += inventoryPayload[ingredientId];
                    }
                    break;

                //In this case negative means the ingredient amount has to be redeemed in the inventory.

                case Actions.INVENTORY_UPDATE_ACTION.BASED_ON_QUANTITY :
                    for(const ingredientId in inventoryPayload) {
                        if(inventoryPayload[ingredientId] > 0) {
                            newAvailableItems[ingredientId].totalAvailableAmount -= inventoryPayload[ingredientId];
                        } else {
                            newAvailableItems[ingredientId].totalAvailableAmount += (inventoryPayload[ingredientId] * -1);
                        }
                    }
                    break;

                //Used to calulate the inventory for the whole cart again.

                case Actions.INVENTORY_UPDATE_ACTION.REMOVE_FROM_INITIAL :
                    newAvailableItems = deepCopy(state.initialInventory);
                    for(const ingredientId in inventoryPayload) {
                        newAvailableItems[ingredientId].totalAvailableAmount -= inventoryPayload[ingredientId];
                    }
                    break;

                default:
                    break;   
            }

            return {
                ...state,
                availableItems: newAvailableItems
            }

        case Actions.CLEAR_INVENTORY :
            return InitialState;

        default :
            return {
                ...state
            }
    }
};

export default Inventory;